import { ChangeDetectionStrategy, Component, OnInit, signal, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ButtonModule } from 'primeng/button';
import { InvitesService } from '@generated/services/invites.service';
import { SpaceService } from '@core/services/space.service';

@Component({
  selector: 'app-invite-activate',
  imports: [ProgressSpinnerModule, ButtonModule],
  templateUrl: './invite-activate.component.html',
  styleUrl: './invite-activate.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InviteActivateComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private invitesService = inject(InvitesService);
  private spaceService = inject(SpaceService);

  loading = signal(true);
  success = signal(false);
  error = signal<string | null>(null);

  ngOnInit() {
    const token = this.route.snapshot.queryParams['token'];
    if (!token) {
      this.loading.set(false);
      this.error.set('Invalid invite link — token is missing.');
      return;
    }

    this.invitesService.apiInvitesActivatePost({ body: { token } }).subscribe({
      next: () => {
        this.spaceService.loadSpaces();
        this.loading.set(false);
        this.success.set(true);
      },
      error: (err) => {
        this.loading.set(false);
        this.error.set(err?.error?.message || 'Failed to activate invite. It may be expired or already used.');
      }
    });
  }

  goToSpaces() {
    this.router.navigate(['/spaces']);
  }
}
